module.exports = __webpack_public_path__ + "static/media/banner@768.b3384b81.png";